import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragWidthCom } from '@platform/components';
import CompMeta from '../../meta/LowCodeComponents/DragWidthCom';
/**
 * @class NCDragWidthCom
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCDragWidthCom
 * @label 左右分栏
 *
 */
class NCDragWidthCom extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
       * @title 区域编码
       * @description 组件标识
       */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title defLeftWid
         * @description 左侧宽度
         */
        defLeftWid: PropTypes.string,
        /**
         * @title leftMinWid
         * @description 左侧最小宽度
         */
        leftMinWid: PropTypes.string,
        /**
         * @title leftDom
         * @description 左侧栏目
         */
        leftDom: PropTypes.node,
        /**
         * @title rightDom
         * @description 右侧栏目
         */
        rightDom: PropTypes.node,
        /**
       * @title 是否可见
       * @description 是否可见
       */
        visible: PropTypes.bool,
    }
    static defaultProps = {
        defLeftWid: '150px',
        leftMinWid: '50px'
    }
    static getCompMeta() {
        return CompMeta;
    }

    render() {
        return (
            <DragWidthCom {...this.props} className="lc-drop-area" />
        )
    }
}
export default NCDragWidthCom;
